import React from 'react';
import { Calendar as BigCalendar, dateFnsLocalizer } from 'react-big-calendar';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import startOfWeek from 'date-fns/startOfWeek';
import getDay from 'date-fns/getDay';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Breadcrumb from '../common/Breadcrumb';

// Localizer config
const locales = {
  'en-US': require('date-fns/locale/en-US'),
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

// Sample events
const events = [
  {
    title: 'Task',
    start: new Date(),
    end: new Date(new Date().setHours(new Date().getHours() + 1) + 36000000),
    assignedTo: 'John Doe',
    task: 'Task',
    color: '#3174ad'
  },
  {
    title: 'Job',
    start: new Date(new Date().getFullYear(), new Date().getMonth(), 5),
    end: new Date(new Date().getFullYear(), new Date().getMonth(), 9),
    //start: new Date('2025-5-5 9:30'),  // May 5, 2025 09:30 local time
    //end: new Date('2025-5-8 10:30'),
    assignedTo: 'Carle',
    task: 'Job',
    color: '#dd2726'
  },
];
const Event = ({ event }) => (
    
    <div>
        <strong>{event.title}</strong>
        <div>Assigned To: {event.assignedTo}</div>
        <div>Task: {event.task}</div>
    </div>
);

const MyCalendar = () => {
  return (
    <>
     <div className="container mx-auto px-4 py-8">
    <Breadcrumb />
    <div className="grid grid-cols-12 gap-4">
      {/* Sidebar (col-md-2 equivalent) */}
      <div className="col-span-12 md:col-span-2 bg-white rounded-lg shadow-md p-4">
        <h2 className="text-lg font-semibold mb-2">To Schedule</h2>
        <ul className="divide-y divide-gray-200 text-gray-700 w-full">
            
            <li className="py-2">
                <details className="group">
                <summary className="flex items-center justify-between cursor-pointer hover:text-blue-600">
                    <span>Jobs</span>
                    <span className="bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-full">2</span>
                </summary>
                <ul className="ml-4 mt-2 space-y-1 text-sm text-gray-600 max-h-60 overflow-y-auto">
                    <li className="hover:text-blue-500 cursor-pointer bg-red-50 p-2 rounded">
                        <p>Assigned To: John Doe</p>
                        <p>10/05/2025 09:30 am</p>
                        <p>10/05/2025 10:30 am</p>
                        <p>Task: Email</p>
                    </li>
                    <li className="hover:text-blue-500 cursor-pointer bg-red-50 p-2 rounded">
                        <p>Assigned To: James</p>
                        <p>10/08/2020 09:30 am</p>
                        <p>10/08/2020 09:30 am</p>
                        <p>Task: Email</p>
                    </li>
                </ul>
                </details>
            </li>
 
            <li className="py-2">
                <details className="group">
                <summary className="flex items-center justify-between cursor-pointer hover:text-blue-600">
                    <span>Tasks</span>
                    <span className="bg-[#3174ad] text-white text-xs font-bold px-2 py-1 rounded-full">5</span>
                </summary>
                <ul className="ml-4 mt-2 space-y-1 text-sm text-gray-600 max-h-60 overflow-y-auto">
                    <li className="hover:text-blue-500 cursor-pointer bg-red-50 p-2 rounded">
                        <p>Assigned To: Alice</p>
                        <p>10/08/2020 09:30 am</p>
                        <p>10/08/2020 09:30 am</p>
                        <p>Task: Email</p>
                    </li>
                    <li className="hover:text-blue-500 cursor-pointer bg-red-50 p-2 rounded">
                        <p>Assigned To: Bob</p>
                        <p>10/08/2020 09:30 am</p>
                        <p>10/08/2020 09:30 am</p>
                        <p>Task: Email</p>
                    </li>
                    <li className="hover:text-blue-500 cursor-pointer bg-red-50 p-2 rounded">
                        <p>Assigned To: Carl</p>
                        <p>10/08/2020 09:30 am</p>
                        <p>10/08/2020 09:30 am</p>
                        <p>Task: Email</p>
                    </li>
                    <li className="hover:text-blue-500 cursor-pointer bg-red-50 p-2 rounded">
                        <p>Assigned To: Rock</p>
                        <p>10/08/2020 09:30 am</p>
                        <p>10/08/2020 09:30 am</p>
                        <p>Task: Email</p>
                    </li>
                    <li className="hover:text-blue-500 cursor-pointer bg-red-50 p-2 rounded">
                        <p>Assigned To: Carter</p>
                        <p>10/08/2020 09:30 am</p>
                        <p>10/08/2020 09:30 am</p>
                        <p>Task: Email</p>
                    </li>
                </ul>
                </details>
            </li>
 
            <li className="py-2">
                <details className="group">
                <summary className="flex items-center justify-between cursor-pointer hover:text-blue-600">
                    <span>Estimations</span>
                    <span className="bg-green-600 text-white text-xs font-bold px-2 py-1 rounded-full">1</span>
                </summary>
                <ul className="ml-4 mt-2 space-y-1 text-sm text-gray-600 max-h-60 overflow-y-auto">
                    <li className="hover:text-blue-500 cursor-pointer bg-red-50 p-2 rounded">
                        <p>Assigned To: Charlie</p>
                        <p>10/08/2020 09:30 am</p>
                        <p>10/08/2020 09:30 am</p>
                        <p>Task: Email</p>
                    </li>
                     
                </ul>
                </details>
            </li>
        </ul>

        <h2 className="text-lg font-semibold mb-2 mt-3">Statuses</h2>
        <ul className="ml-4 mt-2 text-sm text-gray-600 max-h-60 overflow-y-auto">
		  <li className="hover:text-blue-500 cursor-pointer py-1 rounded">
			<div className="flex items-center space-x-2">
			  <div className="w-3 h-3 bg-[#3690d1] rounded-sm"></div>
			  <span className="calendar-font-one calendar-line-height-p">Estimate Requested</span>
			</div>
		  </li>
		   <li className="hover:text-blue-500 cursor-pointer py-1 rounded">
			<div className="flex items-center space-x-2">
			  <div className="w-3 h-3 bg-[#90e815] rounded-sm"></div>
			  <span className="calendar-font-one calendar-line-height-p">Estimate Provided</span>
			</div>
		  </li>
		   <li className="hover:text-blue-500 cursor-pointer py-1 rounded">
			<div className="flex items-center space-x-2">
			  <div className="w-3 h-3 bg-[#1515e8] rounded-sm"></div>
			  <span className="calendar-font-one calendar-line-height-p">Estimate Accepted</span>
			</div>
		  </li>
		   <li className="hover:text-blue-500 cursor-pointer py-1 rounded">
			<div className="flex items-center space-x-2">
			  <div className="w-3 h-3 bg-[#a3a3a3] rounded-sm"></div>
			  <span className="calendar-font-one calendar-line-height-p">Unsuccessful</span>
			</div>
		  </li>
		</ul>
 
      </div>
  
      {/* Main Calendar (col-md-10 equivalent) */}
      <div className="col-span-12 md:col-span-10 bg-white rounded-lg shadow-md p-4">
      <BigCalendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 1000 }}
        components={{
            event: Event,
        }}
        eventPropGetter={(event) => ({
            style: {
            backgroundColor: event.color,
            
            },
        })}
        />

      </div>
    </div>
    </div>
  </>
  
  );
};

export default MyCalendar;
